import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import InlineSVG from 'svg-inline-react';
import PopoverTriggerLayout from 'layouts/PopoverTriggerLayout/PopoverTriggerLayout';
import { transmissionTypes, fuelPolicies } from 'constants/carHire';

import featureSeatsIcon from './images/FeatureSeats.svg';
import featureBagsIcon from './images/FeatureBags.svg';
import featureDoorsIcon from './images/FeatureDoors.svg';
import featureAirConIcon from './images/FeatureAirCon.svg';
import featureTransmissionIcon from './images/FeatureTransmission.svg';
import featureFuelPolicyIcon from './images/FeatureFuelPolicy.svg';

import './CarFeatureList.desktop.scss';
import './CarFeatureList.mobile.scss';

const shortTransmissionLabels = {
  [transmissionTypes.AUTOMATIC]: 'Auto',
  [transmissionTypes.MANUAL]: 'Man',
};

const longTransmissionLabels = {
  [transmissionTypes.AUTOMATIC]: 'Automatic',
  [transmissionTypes.MANUAL]: 'Manual',
};

const mapStateToProps = state => ({
  isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
});

export class CarFeatureList extends Component {
  static propTypes = {
    carHireOption: ImmutablePropTypes.mapContains({
      seats: PropTypes.number,
      bags: PropTypes.number,
      doors: PropTypes.number,
      airConditioning: PropTypes.bool,
      transmission: PropTypes.oneOf(Object.values(transmissionTypes)),
      fuelPolicy: PropTypes.oneOf(Object.values(fuelPolicies)),
    }),
    isMobileBreakpoint: PropTypes.bool.isRequired,
  };

  features = [
    {
      key: 'seats',
      popoverLabel: v => `Fits ${v} people`,
      desktopLabel: v => `x ${v}`,
      icon: featureSeatsIcon,
    },
    {
      key: 'bags',
      popoverLabel: v => `Space for ${v} bag${v > 1 ? 's' : ''}`,
      desktopLabel: v => `x ${v}`,
      icon: featureBagsIcon,
    },
    {
      key: 'doors',
      popoverLabel: v => `${v} door`,
      desktopLabel: v => `x ${v}`,
      icon: featureDoorsIcon,
    },
    {
      key: 'airConditioning',
      popoverLabel: v => `${v ? '' : 'No '}Air Conditioning`,
      desktopLabel: v => `${v ? 'A/C' : 'No A/C'}`,
      icon: featureAirConIcon,
    },
    {
      key: 'transmission',
      popoverLabel: v => longTransmissionLabels[v],
      desktopLabel: v => longTransmissionLabels[v],
      mobileLabel: v => shortTransmissionLabels[v],
      icon: featureTransmissionIcon,
    },
    {
      key: 'fuelPolicy',
      popoverLabel: {
        [fuelPolicies.FULL_TO_EMPTY]: 'Fuel policy: Full to Empty',
        [fuelPolicies.FULL_TO_FULL]: 'Fuel policy: Full to Full',
      },
      desktopLabel: {
        [fuelPolicies.FULL_TO_EMPTY]: 'Full to Empty',
        [fuelPolicies.FULL_TO_FULL]: 'Full to Full',
      },
      mobileLabel: {
        [fuelPolicies.FULL_TO_EMPTY]: 'Empty',
        [fuelPolicies.FULL_TO_FULL]: 'Full',
      },
      icon: featureFuelPolicyIcon,
    },
  ];

  getLabelText(feature, value) {
    const { isMobileBreakpoint } = this.props;
    const mobileLabelSpec = feature.mobileLabel || feature.desktopLabel;
    const labelSpec = isMobileBreakpoint ? mobileLabelSpec : feature.desktopLabel;

    return this.getLabelSpecText(labelSpec, value);
  }

  getLabelSpecText(labelSpec, value) {
    return typeof labelSpec === 'function' ? labelSpec(value) : labelSpec[value];
  }

  getPopoverData() {
    const { carHireOption } = this.props;

    return {
      id: 'car-feature-list__popover',
      body: (
        <div>
          <div>Car specification:</div>
          <ul className="car-feature-list__popover__feature-list">
            {
              this.features.map(feature => (
                <li key={feature.key} className="car-feature-list__popover__feature" data-feature={feature.key}>
                  <InlineSVG src={feature.icon} className="car-feature-list__popover__icon" />
                  { this.getLabelSpecText(feature.popoverLabel, carHireOption.get(feature.key)) }
                </li>
              ))
            }
          </ul>
        </div>
      ),
    };
  }

  render() {
    const { carHireOption, isMobileBreakpoint } = this.props;

    return (
      <div className="car-feature-list">
        <PopoverTriggerLayout content={this.getPopoverData()} position="auto" disabled={isMobileBreakpoint}>
          {
            this.features.map(feature => (
              <div key={feature.key} className="car-feature-list__feature" data-feature={feature.key}>
                <InlineSVG src={feature.icon} className="car-feature-list__feature__icon" />
                { this.getLabelText(feature, carHireOption.get(feature.key)) }
              </div>
            ))
          }
        </PopoverTriggerLayout>
      </div>
    );
  }
}

export default connect(mapStateToProps)(CarFeatureList);



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/CarFeatureList.jsx
 **/